import { render, staticRenderFns } from "./KgjtWebsiteHonor.vue?vue&type=template&id=7f928820&scoped=true&"
import script from "./KgjtWebsiteHonor.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteHonor.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteHonor.vue?vue&type=style&index=0&id=7f928820&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f928820",
  null
  
)

export default component.exports